import { render, staticRenderFns } from "./TrayArrowDown.vue?vue&type=template&id=5dbf2618"
import script from "./TrayArrowDown.vue?vue&type=script&lang=js"
export * from "./TrayArrowDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports